import {MLanguageFiles} from "@elte/translate-backend/interface/lang_file";
import {app, ServiceMethodsLangFile} from './initialFethersjs';
import TRequesrParamsCreate = MLanguageFiles.TRequesrParamsCreate;

export class LanguageFileApi implements MLanguageFiles.IService {
    protected endPoint: ServiceMethodsLangFile;

    constructor() {
        this.endPoint = app.service("lang_file")
    }

    find(params: { target: string; source: string }): Promise<MLanguageFiles.TResponseLanguageFiles[]> {
        return this.endPoint.find({
            query: {
                target: params.target,
                source: params.source
            }
        }) as Promise<MLanguageFiles.TResponseLanguageFiles[]>;
    }

    create(data: MLanguageFiles.TResponseLanguageFiles, params: TRequesrParamsCreate): Promise<MLanguageFiles.TResponseLanguageFiles> {
        return this.endPoint.create(data, {query: params}) as Promise<MLanguageFiles.TResponseLanguageFiles>
    }


}

